
import { defineComponent } from 'vue'
import Flow from '@/components/block/Flow.vue'

export default defineComponent({
  name: 'FlowVisitApplication',

  props: {
    current: Number,
    isEvent: {
      type: Boolean,
      default: false
    }
  },

  components: {
    Flow
  },

  setup(props) {
    const items = [
      {
        label: props.isEvent ? 'イベント申し込み' : '見学申込み',
        current: false
      },
      {
        label: '申込み内容の確認',
        current: false
      },
      {
        label: '申込み完了',
        current: false
      }
    ]

    return {
      items
    }
  }
})
